import { useMemo } from 'react';

/**
 * Ponto de extensão para a futura animação "estilo GPT" de digitação dos campos
 * gerados por IA na revisão pós-sessão.
 *
 * Hoje é um no-op: retorna `fullText` imediatamente. Quando a animação for
 * implementada, este hook passará a revelar o texto progressivamente quando
 * `enabled` for `true` (e os campos deverão ficar somente-leitura durante a
 * revelação para não conflitar com a edição do usuário).
 */
export const useTypewriterValue = (
	fullText: string,
	enabled: boolean,
): string => {
	// `enabled` faz parte da assinatura para a animação futura; ignorado por ora.
	void enabled;
	return useMemo(() => fullText, [fullText]);
};
